import { Trans, useTranslation } from "react-i18next";
import CodeBlock from "../components/CodeBlock";
import RuleRing from "../components/RuleRing";
import styles from "./ColorSystem.module.css";

export default function ColorSystem() {
  const { t } = useTranslation();

  return (
    <article>
      <h1>{t("colorSystem.title")}</h1>
      <p>
        <Trans i18nKey="colorSystem.intro" components={[<code key="0" />]} />
      </p>

      <div className={styles.demo}>
        <RuleRing />
      </div>

      <ol className={styles.list}>
        <li>
          <strong>removeBorder</strong> —{" "}
          <Trans i18nKey="colorSystem.ruleRemoveBorder" components={[<code key="0" />]} />
        </li>
        <li>
          <strong>borderColor</strong> — {t("colorSystem.ruleBorderColor")}
        </li>
        <li>
          <strong>useNitroTheme</strong> — {t("colorSystem.ruleNitro")}
        </li>
        <li>
          <strong>useRoleColor</strong> —{" "}
          <Trans i18nKey="colorSystem.ruleRole" components={[<code key="0" />]} />
        </li>
        <li>
          <strong>theme</strong> —{" "}
          <Trans i18nKey="colorSystem.ruleTheme" components={[<code key="0" />]} />
        </li>
      </ol>

      <p className={styles.note}>
        <Trans
          i18nKey="colorSystem.note"
          components={[<code key="0" />, <em key="1" />, <code key="2" />, <code key="3" />]}
        />
      </p>

      <p className={styles.note}>
        <Trans
          i18nKey="colorSystem.maxColorsNote"
          components={[<code key="0" />, <code key="1" />, <code key="2" />]}
        />
      </p>

      <h2>{t("colorSystem.themesTitle")}</h2>
      <p>
        <Trans i18nKey="colorSystem.themesIntro" components={[<code key="0" />]} />
      </p>

      <CodeBlock title="KiraThemeName">{`"discord" | "midnight" | "sunset" | "neon" | "forest" | "sakura" | "monochrome" | "gold"`}</CodeBlock>

      <p>
        <Trans
          i18nKey="colorSystem.themesUsage"
          components={[<code key="0" />]}
        />
      </p>

      <CodeBlock title="theme example">{`await profileImage(userId, {
  guildId,
  theme: "sunset",
});`}</CodeBlock>

      <p className={styles.note}>
        <Trans
          i18nKey="colorSystem.themesOverrideNote"
          components={[<code key="0" />, <code key="1" />]}
        />
      </p>

      <CodeBlock title={t("colorSystem.publicUsageTitle")}>{`await levelUpImage(userId, level, {
  borderColor: "#7C5CFF",
  useNitroTheme: true,
  useRoleColor: true,
  guildId,
});`}</CodeBlock>

      <CodeBlock title={t("colorSystem.internalTitle")}>{`const borderColors = resolveCardColors({
  custom: options.borderColor,
  removeBorder: options.removeBorder,
  useNitroTheme: options.useNitroTheme,
  nitroColors: data.decoration.profileColors,
  useRoleColor: options.useRoleColor,
  roleColor: data.decoration.roleColor,
  fallback: palette?.borderColor ?? [accentColor],
});`}</CodeBlock>

      <p>
        <Trans
          i18nKey="colorSystem.vocabNote"
          components={[<code key="0" />, <code key="1" />, <code key="2" />, <code key="3" />, <code key="4" />]}
        />
      </p>
    </article>
  );
}
